export default function DSA_Binary_Trees() {
  return <div>DSA_Binary_Trees Component</div>;
}
